import { MAX_FILE_SIZE } from '@features/campaigns/builder/consts/common.ts';

export function isCreativeSizeValid(file: File[]): boolean {
  return file[0].size <= MAX_FILE_SIZE;
}
